<template>
  <div
    v-if="parametrs"
    class="width-100">
    <component
      v-if="hasComponent"
      :is="getComponentName"
      v-bind="componentProps"
      :data-qa="`event-history-params-${value.eventType?.toLowerCase()}`"/>
    <i
      v-else-if="['DOCUMENT_REMOVED'].includes(value.eventType)"
      data-qa="event-history-document">{{ parametrs?.Title }}</i>
    <i
      v-else-if="value.eventType === 'DOCUMENT_REPLACED'"
      data-qa="event-history-document-replaced">{{ parametrs?.OldTitle }} {{ $t('Common.To') }} {{ parametrs?.Title }}</i>
    <JsonViewer
      v-else-if="mixin_isGodMode || isNotProduction"
      :value="value.parameters"/>
  </div>
</template>
<script>
import JsonViewer from 'components/common/elements/JsonViewer.vue'
import EventHistoryDocument from 'components/common/blocks/history/components/parameters/EventHistoryDocument.vue'
import EventHistoryAgreementParams from 'components/common/blocks/history/components/parameters/EventHistoryAgreementParams.vue'
import EventHistoryAutomationProps from 'components/common/blocks/history/components/parameters/EventHistoryAutomationProps.vue'
import EventHistoryTenderChangeProps from 'components/common/blocks/history/components/parameters/EventHistoryTenderChangeProps.vue'
import EventHistoryTenderCopiedParams from 'components/common/blocks/history/components/parameters/EventHistoryTenderCopiedParams.vue'
import EventHistoryNewTenderStageCreatedParams from 'components/common/blocks/history/components/parameters/EventHistoryNewTenderStageCreatedParams.vue'
import EventHistoryTenderCreatedAsNewStageParams from 'components/common/blocks/history/components/parameters/EventHistoryTenderCreatedAsNewStageParams.vue'
import EventHistoryContactPersonChangedProps from 'components/common/blocks/history/components/parameters/EventHistoryContactPersonChangedProps.vue'
import EventHistoryCurrencyRateRecalculationParams from 'components/common/blocks/history/components/parameters/EventHistoryCurrencyRateRecalculationParams.vue'
import EventHistoryAddedNewAdditionalCategoriesParams from 'components/common/blocks/history/components/parameters/EventHistoryAddedNewAdditionalCategoriesParams.vue'

import godModeMixin from 'mixins/godModeMixin'

/**
 * Доп. информация к записям в истории
 */
export default {
  name: 'eventHistoryParams',
  mixins: [ godModeMixin ],
  computed: {
    parametrs() {
      if (!this.value?.parameters) {
        return null
      }
      try {
        return JSON.parse(this.value.parameters)
      } catch {
        return null
      }
    },
    getComponentName() {
      const map = {
        ADDED_NEW_ADDITIONAL_CATEGORIES: 'EventHistoryAddedNewAdditionalCategoriesParams',
        TENDER_COPIED: 'EventHistoryTenderCopiedParams',
        NEW_TENDER_STAGE_CREATED: 'EventHistoryNewTenderStageCreatedParams',
        TENDER_CREATED_AS_NEW_STAGE: 'EventHistoryTenderCreatedAsNewStageParams',
        EDITED_AGREEMENT: 'EventHistoryAgreementParams',
        CHANGED_TENDER_PROPS: 'EventHistoryTenderChangeProps',
        AUTOMATION: 'EventHistoryAutomationProps',
        CURRENCY_RATE_RECALCULATION: 'EventHistoryCurrencyRateRecalculationParams',
        DOCUMENT_ADDED: 'EventHistoryDocument',
        DOCUMENT_REPLACED: 'EventHistoryDocument',
        DOCUMENT_CANCELED: 'EventHistoryDocument',
        CONTACT_PERSON_CHANGED: 'EventHistoryContactPersonChangedProps'
      }
      return map[this.value?.eventType] || null
    },
    hasComponent() {
      return Boolean(this.getComponentName)
    },
    componentProps() {
      if (this.value?.eventType === 'AUTOMATION') {
        return { value: this.parametrs, spr: this.spr }
      }
      if (this.hasComponent) {
        return { value: this.parametrs }
      }
      return {}
    }
  },
  props: {
    value: {
      type: Object
    },
    spr: {
      type: Object
    }
  },
  components: {
    JsonViewer,
    EventHistoryDocument,
    EventHistoryAutomationProps,
    EventHistoryAgreementParams,
    EventHistoryTenderChangeProps,
    EventHistoryTenderCopiedParams,
    EventHistoryNewTenderStageCreatedParams,
    EventHistoryTenderCreatedAsNewStageParams,
    EventHistoryContactPersonChangedProps,
    EventHistoryCurrencyRateRecalculationParams,
    EventHistoryAddedNewAdditionalCategoriesParams,
  }
}
</script>
